<template>
  <a
    :href="props.href"
    :target="props.isExternal ? '_blank' : ''"
    :data-test-id="props.dataTestId"
    class="tw-inline-block tw-underline tw-text-branding-blue-700"
    @click="onClick"
  >
    <span class="tw-flex tw-gap-1 tw-items-center">
      <span v-dompurify-html="props.string" />
      <cb-icon-external-link v-if="props.isExternal" :width="16" />
    </span>
  </a>
</template>

<script setup lang="ts">
interface TLinkProps {
  href: string;
  string: string;
  isExternal?: boolean;
  dataTestId: string;
}

const props = withDefaults(defineProps<TLinkProps>(), {
  isExternal: false,
  dataTestId: "link",
});

const emit = defineEmits<{
  (event: "on-click", value: MouseEvent): void;
}>();

const onClick = (value: MouseEvent): void => {
  emit("on-click", value);
};
</script>
